import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

import type { FixedAsset } from '@/integrations/supabase/fixedasset.models';

export function useLandAssets() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['land-assets'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('fixed_assets')
        .select('*')
        .eq('asset_type', 'land')
        .eq('user_id', user!.id)
        .order('name', { ascending: true });
      if (error) throw error;
      return data as FixedAsset[];
    },
    enabled: !!user,
  });
}
